import { useEffect } from 'react';

import type { Maybe } from 'graphql/jsutils/Maybe';

import { useAnalyticsEvents } from '@atlaskit/teams-app-internal-analytics';
import type { ReportingLinesUser } from '@atlaskit/teams-client/types';

import { useReportingLinesStore } from '../../index';

export const useReportingLines = (userId: string) => {
	const [{ data, isLoading, error }, { getReportingLines }] = useReportingLinesStore();
	const { fireEvent } = useAnalyticsEvents();

	useEffect(() => {
		getReportingLines(userId);
	}, [userId, getReportingLines]);

	const filterNonactiveUsers = (
		users?: Maybe<ReportingLinesUser[]>,
	): Maybe<ReportingLinesUser[]> => {
		return users?.filter((user) => {
			const isActiveAccountStatus = user.pii?.accountStatus === 'active';
			if (!isActiveAccountStatus) {
				// @ts-ignore - hyphenated action subjects are not supported in @atlaskit/teams-app-internal-analytics
				fireEvent('operational.reporting-lines-user.failed', {
					aaid: user.accountIdentifier || 'undefined',
				});
			}
			return isActiveAccountStatus;
		});
	};

	const filteredReportingLines = data?.reportingLines
		? {
				managers: filterNonactiveUsers(data.reportingLines.managers),
				peers: filterNonactiveUsers(data.reportingLines.peers),
				reports: filterNonactiveUsers(data.reportingLines.reports),
				user: data.reportingLines.user,
				lastModifiedDate: data.reportingLines.lastModifiedDate,
			}
		: data?.reportingLines;

	return {
		isLoading,
		reportingLines: filteredReportingLines,
		error,
	};
};
